import React from "react";

import { formatBdtAmount } from "../../utils/assetManagerPnl";
import { formatShareQty } from "../../utils/investorRedeemEligibility";
import { projectFundsRaisedCash } from "../../utils/investmentPricing";
import { projectSupplyMetrics } from "../../utils/projectShareMetrics";

/**
 * Live cap-table strip for funded project cards (holdings-based).
 */
export default function FundedProjectSupplyMetrics({ project }) {
  const m = projectSupplyMetrics(project);

  return (
    <div className="investor-funded-supply" aria-label="Share supply" aria-live="polite" aria-atomic="true">
      <div className="investor-funded-supply__cell">
        <span className="investor-funded-supply__label">Total shares</span>
        <strong>{formatShareQty(m.totalShares)}</strong>
      </div>
      <div className="investor-funded-supply__cell">
        <span className="investor-funded-supply__label">Issued shares</span>
        <strong>{formatShareQty(m.issuedShares)}</strong>
      </div>
      <div className="investor-funded-supply__cell">
        <span className="investor-funded-supply__label">Available shares</span>
        <strong>{formatShareQty(m.availableShares)}</strong>
      </div>
      <div className="investor-funded-supply__cell">
        <span className="investor-funded-supply__label">Shareholders</span>
        <strong>{m.shareholders}</strong>
      </div>
      <div className="investor-funded-supply__cell investor-funded-supply__cell--money">
        <span className="investor-funded-supply__label">Fundraised</span>
        <strong>{formatBdtAmount(projectFundsRaisedCash(project))}</strong>
      </div>
    </div>
  );
}
